/* eslint-disable @next/next/no-img-element */
import { formatCurrency } from '@/helpers/format';
import usePrefix from '@/hooks/usePrefix';
import { useMobxStores } from '@/stores';
import {
  Button,
  Popover,
  Rate,
  Tabs,
} from 'antd';
import { CheckOutlined } from './Icons';
import Image from 'next/image';
import { observer } from 'mobx-react-lite';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useState, useEffect, useRef } from 'react';
import ButtonStatus from './ButtonStatus2';
import VerticalSH from './FacilityHighlights/VerticalSH';
import SearchImage from './SearchImage';
import { isShowHighlights } from '@/helpers/highlights';
import FacilityTypeDeal from '@/utils/facilityTypeDeal';
import { CDN1, CDN2 } from '@/helpers/api';
import { mapRateSearchName, mapReviewStars } from '@/utils/tools';
import { getParkingAtPath, getUrlCodeOrSlug } from '@/utils/newparkingatroutes';
import NeedMoreData from './NeedMoreData';
import { IAirport } from '@/types';
import { isServer } from '@/utils/isServer';
import { setStorageCheckinCheckout } from '@/hooks/useLocalstorage';
import { useTranslation } from 'react-i18next';
import SidePopover from './FacilityHighlights/SidePopover';

function checkShowFull(facility_url_code: string) {
  return !facility_url_code?.toLocaleLowerCase().startsWith('arv');
}

const Card = ({
  configInfo,
  item,
  index,
  cardsRef,
  checkin,
  checkout,
  hasHighlight,
  deviceType,
  isCity,
}) => {
  const prefix = usePrefix();
  const router = useRouter();
  const { searchStore } = useMobxStores();
  const [showWhatParkBtn, setShowWhatParkBtn] = useState<boolean>(false);
  const [activeKey, setActiveKey] = useState<string>('description');
  const [popoverVisible, setPopoverVisible] = useState<boolean>(false);

  const { TabPane } = Tabs;

  const openMoreInformation = async (e): Promise<void> => {
    e.preventDefault();
    setShowWhatParkBtn(!showWhatParkBtn);
    setActiveKey('description');
    return;
  };

  const openViewHighlights = async (e): Promise<void> => {
    e.preventDefault();
    setShowWhatParkBtn(!showWhatParkBtn);
    setActiveKey('highlights');
    return;
  };

  function preventClick(e) {
    if (!e) e = window.event;
    e.stopPropagation();
    return;
  }

  useEffect(() => {
    sessionStorage.removeItem('checkin');
    sessionStorage.removeItem('checkout');
  }, []);

  const UnbrandedImages = [
    CDN2() + '/staticmyapp/cards-default-image.webp',
    CDN2() + '/staticmyapp/pvd-airport.webp',
    CDN2() + '/staticmyapp/default-image-3.webp',
  ];

  let lastUnbrandedIndex = null;

  const getUnbrandedImage = () => {
    let randomIndex = index % UnbrandedImages.length;
    if (randomIndex === lastUnbrandedIndex) {
      randomIndex = (randomIndex + 1) % UnbrandedImages.length;
    }
    lastUnbrandedIndex = randomIndex;
    return UnbrandedImages[randomIndex];
  };

  let imageUrl = item.facility_is_image_uploaded
    ? `${CDN1}/upload/${configInfo.environment}/${item.facility_id}`
    : getUnbrandedImage();

  const arriveLogo = item.highlights.find((x) => x.type === 'arrive_logo_url');
  if (arriveLogo) {
    imageUrl = arriveLogo.description;
  }

  return item.date_sold_out > 0 ? (
    <>
      <div
        key={item.facility_id + index}
        ref={(el) => (cardsRef.current[index] = el)}
        className={`relative mx-auto bg-white rounded-[0.675rem] border shadow-lg overflow-hidden  transition-all duration-300 ${item.selected ? 'shadow-2xl' : ''} opacity-60`}
      >
        {/* <div
          className="flex flex-col xl:flex-row w-full "
        >
          <div className="xl:flex-[0_0_20%] flex justify-center items-center p-2">
            <div className="relative w-full h-24">
              <SearchImage
                src={imageUrl}
                native={!!arriveLogo}
                placeholder="blur"
                fill
                style={{ objectFit: 'contain' }}
                blurDataURL={getUnbrandedImage()}
                errorImage={getUnbrandedImage()}
                alt={`Airport: ${item.facility_lot} Background`}
                key={item.facility_id}
                quality={100}
              />
            </div>
          </div>
          <div className="w-full flex flex-col space-y-4">
            <div className="flex flex-row w-full p-4">
              <div className="flex flex-col col-span-2 px-0 self-center mx-auto w-3/5 ">
                <div className="w-full space-y-2">
                  <h3 className="text-lg font-semibold text-left w-full truncate">
                    {item.facility_lot}
                  </h3>
                  {checkShowFull(item.facility_url_code) && (
                    <div className="flex flex-row items-center gap-2">
                      <Rate
                        allowHalf
                        disabled
                        value={1}
                        count={1}
                        className='text-base'
                      />
                      <p className=" text-gray-500">
                        ({item.num_review} {item.num_review === 1 ? 'review' : 'reviews'})
                      </p>
                    </div>
                  )}
                </div>
              </div>
              {item.facilityParkingType == 3 ||
                item.facilityParkingType == 4 ? (
                <p className="w-full text-base text-right">
                  {formatCurrency({
                    value: item.facility_solid_selling_price
                      ? item.facility_solid_selling_price
                      : item.facility_afee,
                    locale: 'en-US',
                    currency: 'USD',
                  })} {' '}
                  <small className="text-sm text-onair-gray">
                    {item.facilityParkingType == 3
                      ? 'Sleep and Park'
                      : 'Monthly Park'}
                  </small>
                </p>
              ) : (
                <p className="w-full text-base text-right">
                  {formatCurrency({
                    value: item.facility_selling_price,
                    locale: 'en-US',
                    currency: 'USD',
                  })}{' '}
                  <small className="text-sm text-onair-gray lowercase">
                    {mapRateSearchName(item)}
                  </small>
                </p>
              )}
            </div>
          </div>
        </div>
        <div
          className={`w-full overflow-hidden flex justify-between border-t mt-2 py-2 px-1`}
        >
          <ButtonStatus
            status={searchStore.facilityStatus(item)}
            facility_url_code={item.facility_url_code}
            minDays={item.facility_min_days}
            maxDays={item.facility_max_days}
            configInfo={configInfo}
            item={item}
          />
        </div> */}
        <div
          className="flex flex-col xl:flex-row w-full"
        >
          {deviceType === 'mobile' ? (
            <>
              <div className="flex flex-row w-full pt-4 gap-x-1">
                <div className="relative w-[50px] h-[50px]">
                  <SearchImage
                    src={imageUrl}
                    native={!!arriveLogo}
                    placeholder="blur"
                    fill
                    style={{ objectFit: 'contain' }}
                    blurDataURL={getUnbrandedImage()}
                    errorImage={getUnbrandedImage()}
                    alt={`Airport: ${item.facility_lot} Background`}
                    key={item.facility_id}
                    quality={100}
                  />
                </div>
                <div className="flex flex-row w-full flex-1 ">
                  <div className="flex flex-col w-full">
                    <h3 className="text-base xl:text-lg font-semibold truncate max-w-[18rem]">
                      {item.facility_lot}
                    </h3>
                    {checkShowFull(item.facility_url_code) && (
                      <div className="flex items-center gap-x-2">
                        <Rate
                          allowHalf
                          disabled
                          value={1}
                          count={1}
                          className='text-sm'
                        />
                        <p
                          className={`font-semibold rounded-md text-sm`}
                        >
                          {item.facility_review_avg.toFixed(1)}
                        </p>
                        <p className="text-sm text-gray-500">
                          ({item.num_review})
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="flex flex-row items-center justify-between w-full p-2">
                <ButtonStatus
                  status={searchStore.facilityStatus(item)}
                  facility_url_code={item.facility_url_code}
                  minDays={item.facility_min_days}
                  maxDays={item.facility_max_days}
                  configInfo={configInfo}
                  item={item}
                />
              </div>
            </>
          ) : (
            <>
              <div className="flex-shrink-0 pl-2">
                <div className="relative w-20 h-20 overflow-hidden">
                  <SearchImage
                    src={imageUrl}
                    native={!!arriveLogo}
                    placeholder="blur"
                    fill
                    style={{ objectFit: 'contain' }}
                    blurDataURL={getUnbrandedImage()}
                    errorImage={getUnbrandedImage()}
                    alt={`Airport: ${item.facility_lot} Background`}
                    key={item.facility_id}
                    quality={100}
                    className={""}
                  />
                </div>
              </div>
              <div className="hidden xl:flex flex-col w-full py-1 px-2">
                <div className="flex flex-row">
                  <div className="xl:flex-[1_2_auto] flex flex-col justify-start w-auto">
                    <h3 className="text-lg font-semibold truncate xl:max-w-xs">
                      {item.facility_lot}
                    </h3>
                    {checkShowFull(item.facility_url_code) && (
                      <div className="flex items-center gap-x-2">
                        <Rate
                          allowHalf
                          disabled
                          value={1}
                          count={1}
                          className='text-base'
                        />
                        <p
                          className={`font-semibold rounded-md text-sm`}
                        >
                          {item.facility_review_avg.toFixed(1)}
                        </p>
                        <p className="text-sm text-gray-500">
                          ({item.num_review})
                        </p>
                      </div>
                    )}
                  </div>
                </div>
                <div className="">
                  <ButtonStatus
                    status={searchStore.facilityStatus(item)}
                    facility_url_code={item.facility_url_code}
                    minDays={item.facility_min_days}
                    maxDays={item.facility_max_days}
                    configInfo={configInfo}
                    item={item}
                  />
                </div>
              </div>
            </>)}
        </div>
      </div>
    </>
  ) : (
    <div
      key={item.facility_id + index}
      ref={(el) => (cardsRef.current[index] = el)}
      className="rounded-lg overflow-hidden bg-white shadow-md hover:shadow-lg border border-gray-100 transition-all duration-300 cursor-pointer p-2"
    >
      <Link
        href={`${prefix}/${getParkingAtPath(item)}/${getUrlCodeOrSlug(item)}`}
        passHref
        legacyBehavior
      >
        <div
          className="flex flex-col xl:flex-row w-full "
        >
          {deviceType === 'mobile' ? (
            <>
              {item.facility_is_express_deal > 0 ? (
                <p className="text-xs text-white bg-primary px-4 py-0.5 w-full rounded-t-md">{FacilityTypeDeal(item)}</p>
              ) : <div className="h-4 py-0.5"></div>}

              <div className="flex flex-row w-full pt-4 gap-x-1">
                <div className="relative w-[50px] h-[50px]">
                  <SearchImage
                    src={imageUrl}
                    native={!!arriveLogo}
                    placeholder="blur"
                    fill
                    style={{ objectFit: 'contain' }}
                    blurDataURL={getUnbrandedImage()}
                    errorImage={getUnbrandedImage()}
                    alt={`Airport: ${item.facility_lot} Background`}
                    key={item.facility_id}
                    quality={100}
                  />
                </div>
                <div className="flex flex-row w-full flex-1 ">
                  <div className="flex flex-col w-full">
                    <h3 className="text-base xl:text-lg font-semibold truncate max-w-[10.5rem]">
                      {item.facility_lot}
                    </h3>
                    {checkShowFull(item.facility_url_code) && (
                      <div className="flex items-center gap-x-2">
                        <Rate
                          allowHalf
                          disabled
                          value={1}
                          count={1}
                          className='text-sm'
                        />
                        <p
                          className={`font-semibold rounded-md text-sm`}
                        >
                          {item.facility_review_avg.toFixed(1)}
                        </p>
                        <p className="text-sm text-gray-500">
                          ({item.num_review})
                        </p>
                      </div>
                    )}
                  </div>
                  {item.facilityParkingType == 3 ||
                    item.facilityParkingType == 4 ? (
                    <div className="flex flex-col justify-center items-end text-right w-full">
                      <div className="">
                        <p className="text-sm font-bold">
                          {formatCurrency({
                            value: item.facility_solid_selling_price
                              ? item.facility_solid_selling_price
                              : item.facility_afee,
                            locale: 'en-US',
                            currency: 'USD',
                          })} {' '}
                          <span className="text-xs">
                            {item.facilityParkingType == 3
                              ? 'Sleep and Park'
                              : 'Monthly Park'}
                          </span>
                        </p>
                        <p className="text-xs">
                          {formatCurrency({
                            value: item.facility_total_price,
                            locale: 'en-US',
                            currency: 'USD',
                          })}{' '}
                          total
                        </p>
                      </div>
                    </div>
                  ) : (
                    <div className="flex flex-col justify-center items-end text-right w-full">
                      <div>
                        <p className="text-sm font-bold">
                          {formatCurrency({
                            value: item.facility_selling_price,
                            locale: 'en-US',
                            currency: 'USD',
                          })}{' '}
                          <span className="text-xs">
                            {mapRateSearchName(item)}
                          </span>
                        </p>
                        <p className="text-xs">
                          {formatCurrency({
                            value: item.facility_total_price,
                            locale: 'en-US',
                            currency: 'USD',
                          })}{' '}
                          total
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <small className="text-[0.6rem] text-green-600 text-right">
                <CheckOutlined className="mr-1" />
                Total includes taxes and fees
              </small>
              {isShowHighlights(item.highlights) && (
                <Popover
                  content={
                    <SidePopover
                      facility={item}
                      highlights={item.highlights}
                      size="small"
                    />
                  }
                  trigger={deviceType === 'desktop' ? 'hover' : 'click'}
                  overlayClassName={`${deviceType !== 'desktop' ? 'search-list-popover' : 'search-list-popover-desktop'}`}
                >
                  <div
                    onClick={(e) => e.stopPropagation()}
                    onTouchStart={(e) => e.stopPropagation()}
                  >
                    <VerticalSH
                      facility={item}
                      highlights={item.highlights}
                      size="small"
                      className="flex flex-col place-items-start px-2"
                      airportinitials={item?.airport_initials}
                      isCity={isCity}
                    />
                  </div>
                </Popover>
              )}
              <div className="flex flex-row items-center justify-between w-full">
                <Button
                  className="w-auto ml-auto rounded-full border-none"
                  href={`${prefix}/${getParkingAtPath(
                    item
                  )}/${getUrlCodeOrSlug(item)}`}
                >
                  <span className="font-bold text-base text-primary">
                    View Details
                  </span>
                </Button>
              </div>
            </>
          ) : (
            <>
              <div className="flex-shrink-0">
                <div className="relative w-20 h-20 overflow-hidden">
                  <SearchImage
                    src={imageUrl}
                    native={!!arriveLogo}
                    placeholder="blur"
                    fill
                    style={{ objectFit: 'contain' }}
                    blurDataURL={getUnbrandedImage()}
                    errorImage={getUnbrandedImage()}
                    alt={`Airport: ${item.facility_lot} Background`}
                    key={item.facility_id}
                    quality={100}
                    className={""}
                  />
                </div>
              </div>
              <div className="hidden xl:flex flex-row w-full">
                <div className="xl:flex-[1_2_auto] pl-2 py-2 flex flex-col justify-start w-auto">
                  <h3 className="text-lg font-semibold truncate xl:max-w-xs">
                    {item.facility_lot}
                  </h3>
                  {checkShowFull(item.facility_url_code) && (
                    <div className="flex items-center gap-x-2">
                      <Rate
                        allowHalf
                        disabled
                        value={1}
                        count={1}
                        className='text-base'
                      />
                      <p
                        className={`font-semibold rounded-md text-sm`}
                      >
                        {item.facility_review_avg.toFixed(1)}
                      </p>
                      <p className="text-sm text-gray-500">
                        ({item.num_review})
                      </p>
                    </div>
                  )}
                  {deviceType !== 'mobile' && (
                    <>
                      {item.facility_is_express_deal > 0 ? (
                        <p className="font-semibold text-xs text-white bg-primary px-1.5 py-1 w-fit rounded-md mb-4">{FacilityTypeDeal(item)}</p>
                      ) : (
                        <div className='py-1 h-5'></div>
                      )}
                    </>
                  )}
                  {isShowHighlights(item.highlights) && (
                    <Popover
                      content={
                        <SidePopover
                          facility={item}
                          highlights={item.highlights}
                          size="small"
                        />
                      }
                      trigger={deviceType === 'desktop' ? 'hover' : 'click'}
                      overlayClassName={`${deviceType !== 'desktop' ? 'search-list-popover' : `search-list-popover-desktop`}`}
                    >
                      <VerticalSH
                        facility={item}
                        highlights={item.highlights}
                        size="small"
                        className="flex flex-col justify-items-start"
                        airportinitials={item?.airport_initials}
                        isCity={isCity}
                      />
                    </Popover>
                  )}
                </div>
                <div className="hidden py-2 pr-2 xl:flex flex-col justify-between xl:items-end text-right w-full xl:max-w-[13rem] xl:self-center">
                  {item.facilityParkingType == 3 ||
                    item.facilityParkingType == 4 ? (
                    <div className="flex flex-col justify-center items-end text-right gap-4 w-full">
                      <div>
                        <p className="text-lg font-bold">
                          {formatCurrency({
                            value: item.facility_solid_selling_price
                              ? item.facility_solid_selling_price
                              : item.facility_afee,
                            locale: 'en-US',
                            currency: 'USD',
                          })} {' '}
                          {item.facilityParkingType == 3
                            ? 'Sleep and Park'
                            : 'Monthly Park'}
                        </p>
                        <p className="text-base">
                          {formatCurrency({
                            value: item.facility_total_price,
                            locale: 'en-US',
                            currency: 'USD',
                          })}{' '}
                          total
                        </p>
                        <small className="text-sm text-green-600">
                          <CheckOutlined className="mr-1" />
                          Total includes taxes and fees
                        </small>
                      </div>
                      <Button
                        type="primary"
                        className="w-4/5 rounded-full"
                        size="large"
                        href={`${prefix}/${getParkingAtPath(
                          item
                        )}/${getUrlCodeOrSlug(item)}`}
                      >
                        <span className="font-bold">
                          View Details
                        </span>
                      </Button>
                    </div>
                  ) : (
                    <div className="flex flex-col justify-center items-end text-right gap-14 w-full">
                      <div>
                        <p className="text-lg font-bold ">
                          {formatCurrency({
                            value: item.facility_selling_price,
                            locale: 'en-US',
                            currency: 'USD',
                          })}{' '}
                          {mapRateSearchName(item)}
                        </p>
                        <p className="text-base">
                          {formatCurrency({
                            value: item.facility_total_price,
                            locale: 'en-US',
                            currency: 'USD',
                          })}{' '}
                          total
                        </p>
                        <small className="text-sm text-green-600">
                          <CheckOutlined className="mr-1" />
                          Total includes taxes and fees
                        </small>
                      </div>
                      <Button
                        type="primary"
                        className="w-4/5 rounded-full"
                        size="large"
                        href={`${prefix}/${getParkingAtPath(
                          item
                        )}/${getUrlCodeOrSlug(item)}`}
                      >
                        <span className="font-bold">
                          View Details
                        </span>
                      </Button>
                    </div>
                  )}
                </div>
              </div>
            </>)}

        </div>
      </Link>
    </div>
  );
};

function SearchList({
  configInfo,
  checkin,
  checkout,
  deviceType,
  searchAlternate,
  currentAirport,
  isNewLanding,
  isCity,
  testScope,
}: {
  configInfo: any;
  checkin: string;
  checkout: string;
  deviceType: string;
  searchAlternate: any;
  currentAirport?: IAirport;
  isNewLanding?: boolean;
  isCity?: boolean;
  testScope?: any;
}) {
  const { searchStore } = useMobxStores();
  const cardsRef = useRef<any>([]);
  const { t } = useTranslation();

  const hasHighlight = searchStore.filteredFacilities?.some(
    (x) => x.facility_branded == 1
  );

  const baseFacilities =
    searchStore.filteredFacilities ?? searchAlternate?.result;


  const showLowestPriceMessage = baseFacilities?.some(
    (item) => item.facility_disable_lowest_price === 0
  );
  useEffect(() => {
    if (!isServer) {
      setStorageCheckinCheckout(checkin, checkout);
    }
  }, [checkin, checkout]);
  return (
    // <Skeleton
    //   active
    //   loading={searchStore.isLoading}
    //   className="max-w-2xl mx-auto"
    // >
    <>
      {baseFacilities?.map((item, index) => {
        return (
          <div key={index} className="mb-4 mt-2 px-2">
            <Card
              configInfo={configInfo}
              item={item}
              index={index}
              cardsRef={cardsRef}
              checkin={checkin}
              checkout={checkout}
              hasHighlight={hasHighlight}
              deviceType={deviceType}
              isCity={isCity}
            />
          </div>
        );
      })}
      {!isNewLanding && showLowestPriceMessage && (
        <p className="text-[0.625rem] ml-2 mt-1.5 mb-4 xl:mb-2 xl:text-sm">
          {t('price_match_guarantee')}
        </p>
      )}

      {searchStore.filteredFacilities?.length === 0 && (
        <NeedMoreData airport={currentAirport} />
      )}
    </>
  );
}

export default observer(SearchList);
